// extracted by mini-css-extract-plugin
export default {"container":"Jn-z","disabled":"Kn-z","subtotal":"Ln-z","legal":"Mn-z"};